document.addEventListener('DOMContentLoaded', function () {
  var pills = document.querySelectorAll('.nsp-collection-filters__pill');
  var cards = document.querySelectorAll('.nsp-collection-card');

  if (!pills.length || !cards.length) return;

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      pills.forEach(function (p) {
        p.classList.remove('nsp-collection-filters__pill--active');
      });
      pill.classList.add('nsp-collection-filters__pill--active');

      var value = pill.getAttribute('data-filter-value') || '';

      cards.forEach(function (card) {
        if (!value) {
          card.style.display = '';
          return;
        }

        var categories = (card.getAttribute('data-categories') || '')
          .split(',')
          .map(function (entry) { return entry.trim(); });

        card.style.display = categories.indexOf(value) !== -1 ? '' : 'none';
      });
    });
  });
});
